var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoison(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3694 12.2953C14.9851 11.0034 16 9.13675 16 7.06094C16 3.16128 12.4183 0 8 0C3.58172 0 0 3.16128 0 7.06094C0 9.06181 0.942928 10.8683 2.45798 12.1532C2.36616 12.4702 2.31579 12.815 2.31579 13.1756C2.31579 14.7355 3.25834 16 4.42106 16C5.17656 16 5.83913 15.4661 6.21053 14.6642C6.58194 15.4661 7.2445 16 8 16C8.68869 16 9.30013 15.5564 9.68422 14.8705C10.0683 15.5564 10.6798 16 11.3684 16C12.5311 16 13.4737 14.7355 13.4737 13.1756C13.4737 12.8682 13.4371 12.5723 13.3694 12.2953ZM12.6316 7.20097C12.6316 9.18078 10.5108 10.7858 7.89475 10.7858C5.27866 10.7858 3.15791 9.18078 3.15791 7.20097C3.15791 5.22116 5.27866 3.61619 7.89475 3.61619C10.5108 3.61619 12.6316 5.22116 12.6316 7.20097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoison);
export default __webpack_public_path__ + "static/media/poison.38af4fd22e5fb5d38959ad84eaca9625.svg";
export { ForwardRef as ReactComponent };